import {Theme} from '@material-ui/core';
import {CreateCSSProperties} from '@material-ui/styles/withStyles/withStyles';

export const getBlockTitleStyles = (theme: Theme): CreateCSSProperties => ({
	color: theme.palette.text.primary,
	fontSize: theme.typography.pxToRem(40),
	lineHeight: theme.typography.pxToRem(48),
	letterSpacing: '0.08em',
});
